import React from "react";
import SearchFilter from "components/searchFilter";
import useTranslation from "utils/hooks/useTranslation";

interface IPropsSearchFilterReaders {
  readersUpdateFilter: (...args) => void;
  readersChangeFieldValue: (...args) => void;
}

const ReadersFilter = ({ readersUpdateFilter, readersChangeFieldValue }: IPropsSearchFilterReaders) => {
  const SEARCH_PLACEHOLDER = `${useTranslation({
    id: "unit_search",
  })}...`;

  return <SearchFilter placeholder={SEARCH_PLACEHOLDER} updateFilter={readersUpdateFilter} changeFieldValue={readersChangeFieldValue} numbersTypedCharacters={3} />;
};

export default ReadersFilter;
